import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { createHostAdapter } from '../lib/host-adapters';
const HostContext = createContext(null);
/**
 * Provider component that supplies host-specific context to the app
 */
export function HostProvider({ hostType, children }) {
    const value = useMemo(() => {
        const adapter = createHostAdapter(hostType);
        return {
            hostType,
            adapter,
            isOutlook: hostType === 'outlook',
            isWord: hostType === 'word',
            isPowerPoint: hostType === 'powerpoint',
            isExcel: hostType === 'excel',
        };
    }, [hostType]);
    return _jsx(HostContext.Provider, { value: value, children: children });
}
/**
 * Hook to access the host context
 * @throws Error if used outside of HostProvider
 */
export function useHost() {
    const context = useContext(HostContext);
    if (!context) {
        throw new Error('useHost must be used within a HostProvider');
    }
    return context;
}
/**
 * Hook to access the host adapter
 * @throws Error if used outside of HostProvider
 */
export function useHostAdapter() {
    const { adapter } = useHost();
    return adapter;
}
